import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { IconCheck, IconLanguage } from '@tabler/icons-react';

import { LOCALES, useI18n } from '../i18n';

/**
 * Header language picker.
 *
 * A menu rather than a two-state toggle: a toggle is fine for two languages and
 * wrong the moment a third arrives, and the label a toggle has to show ("TR")
 * is ambiguous about whether it names the current language or the next one.
 */
export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const current = LOCALES.find((l) => l.value === locale);

  return (
    <Menu position="bottom-end" withArrow shadow="md">
      <Menu.Target>
        <Tooltip label={t('app.language.change')} withArrow>
          <ActionIcon
            variant="default"
            size="lg"
            aria-label={t('app.language.change')}
            data-testid="language-switcher"
            data-locale={locale}
          >
            <IconLanguage size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('app.language')}</Menu.Label>
        {LOCALES.map((l) => (
          <Menu.Item
            key={l.value}
            data-testid={`language-option-${l.value}`}
            leftSection={<span aria-hidden>{l.flag}</span>}
            rightSection={l.value === current?.value ? <IconCheck size={14} /> : null}
            onClick={() => setLocale(l.value)}
          >
            {l.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
